import { useMutation, useQueryClient } from "@tanstack/react-query"

import { createQuestionnaire } from "../../services/questionnaires";
import { IIndicators } from "../../types/indicator";
import { toast } from "react-toastify";

const useCreateQuestionnaire = (indicator: IIndicators) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: createQuestionnaire,
        onMutate: () => {
            indicator.setIsProcessRunning(true);
            indicator.setIsServiceError(null);
        },
        onSuccess: (statusCode) => {
            if (statusCode === 200) {
                queryClient.invalidateQueries({ queryKey: ["questionnaires"] });
                indicator.setIsProcessRunning(false);
                indicator.setIsServiceError(null);
                toast.success("Questionnaire created successfully");
            }
        },
        onError: (error: any) => {
            indicator.setIsServiceError(error?.response?.data?.message);
            indicator.setIsProcessRunning(false);
            toast.error(error?.response?.data?.message);
        }
    })
}

export default useCreateQuestionnaire;